// extracted by mini-css-extract-plugin
module.exports = {"center":"SelectTeamDialog_center__Gy_El","dialog":"SelectTeamDialog_dialog__jBydu"};